import { fcaFastApi } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getDynamicTables = params => fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}`, { params });

// The dropdown endpoint pages at 100 by default; menu and tab consumers need every published table.
export const DYNAMIC_TABLE_DROPDOWN_MAX_LIMIT = 1000;

export const getDynamicTablesDropdown = params =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/dropdown`, {
        params: { limit: DYNAMIC_TABLE_DROPDOWN_MAX_LIMIT, offset: 1, ...params }
    });

export const getListForDynamicTableFilter = params =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.getListForDynamicTableFilter}`, { params });

// field_filter is passed raw: the gateway's paramsSerializer already JSON-stringifies that key and
// pre-stringifying would double-encode it. table_ids is not in that list, so it still needs it.
const fieldFinderParams = ({ table_ids, field_filter, ...rest }) => ({
    ...rest,
    ...(table_ids?.length ? { table_ids: JSON.stringify(table_ids) } : {}),
    ...(field_filter?.length ? { field_filter } : {})
});

export const getFieldFinderFields = (params, config = {}) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/field_finder/fields`, {
        ...config,
        params: fieldFinderParams(params)
    });

export const getFieldFinderValues = (params, config = {}) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/field_finder/values`, {
        ...config,
        params: fieldFinderParams(params)
    });

export const addDynamicTable = params => fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}`, params);

export const getDynamicTableById = id => fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${id}`);

export const updateDynamicTable = (id, params) => fcaFastApi.put(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${id}`, params);

export const deleteDynamicTable = (id, isPermanent) =>
    fcaFastApi.delete(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${id}`, { params: { permanent: !!isPermanent } });

export const getDynamicTableBands = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/bands`, { params });

export const addDynamicTableBand = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/bands`, params);

export const updateDynamicTableBand = (tableId, bandId, params) =>
    fcaFastApi.put(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/bands/${bandId}`, params);

export const deleteDynamicTableBand = (tableId, bandId) =>
    fcaFastApi.delete(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/bands/${bandId}`);

export const getListForDynamicTableBandFilter = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/bands/get_list`, { params });

export const getDynamicTableFields = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields`, { params });

export const getDynamicTableFieldsGrouped = tableId =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields/grouped`);

export const getDynamicTableFieldById = (tableId, fieldId) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields/${fieldId}`);

export const addDynamicTableField = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields`, params);

export const updateDynamicTableField = (tableId, fieldId, params) =>
    fcaFastApi.put(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields/${fieldId}`, params);

export const deleteDynamicTableField = (tableId, fieldId) =>
    fcaFastApi.delete(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields/${fieldId}`);

export const reorderDynamicTableFields = (tableId, params) =>
    fcaFastApi.put(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields/reorder`, params);

export const getListForDynamicTableFieldFilter = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/fields/get_list`, { params });

export const getDynamicTableRecords = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records`, { params });

export const exportDynamicTableRecords = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records`, {
        responseType: "blob",
        params: { ...params, report: true }
    });

export const getDynamicTableRecordTotals = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/totals`, { params });

export const getDynamicTableRecordById = (tableId, recordId) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/${recordId}`);

export const addDynamicTableRecord = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records`, params);

export const updateDynamicTableRecord = (tableId, recordId, params) =>
    fcaFastApi.put(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/${recordId}`, params);

export const deleteDynamicTableRecord = (tableId, recordId) =>
    fcaFastApi.delete(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/${recordId}`);

export const getDynamicTableRecordCommonData = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/edit_multiple`, params);

export const bulkEditDynamicTableRecords = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/bulk_edit`, params);

export const bulkDeleteDynamicTableRecords = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/bulk_delete`, params);

export const getListForDynamicTableRecordFilter = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/get_list`, { params });

export const getDynamicTableImportTemplate = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/import/template`, { responseType: "blob", params });

export const validateDynamicTableImport = (tableId, formData, onUploadProgress) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/import/validate`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress
    });

export const bulkAssignDynamicTableRecords = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/bulk_assign`, params);

export const bulkUnassignDynamicTableRecords = (tableId, params) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/bulk_unassign`, params);

export const getDynamicTableRecordLinkedEntities = (tableId, recordId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/${recordId}/linked_entities`, { params });

export const getListForLinkedEntityFilter = (tableId, recordId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/${recordId}/linked_entities/get_list`, { params });

export const getDynamicTableRecordIds = (tableId, params) =>
    fcaFastApi.get(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/records/record_ids`, { params });

export const confirmDynamicTableImport = (tableId, formData) =>
    fcaFastApi.post(`${serviceEndpoints.dynamicTableEndPoints.dynamicTable}/${tableId}/import`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });

